/**
 * pcn-landing.js — Animación de entrada de las landings de campaña.
 *
 * Progressive enhancement: marca <html class="pcnl-anim"> SOLO si puede
 * animar. Si este script no carga, el CSS deja todo visible — nunca queda
 * contenido invisible por un fallo de JS.
 */
(function () {
  'use strict';

  var root = document.documentElement;

  function revelarTodo(nodos) {
    for (var i = 0; i < nodos.length; i++) nodos[i].classList.add('is--in');
  }

  function init() {
    var nodos = document.querySelectorAll('.pcn-landing .pcnl-rv');
    if (!nodos.length) return;

    var sinMovimiento = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // Sin IntersectionObserver o con movimiento reducido: mostrar sin animar
    if (sinMovimiento || !('IntersectionObserver' in window)) {
      revelarTodo(nodos);
      return;
    }

    root.classList.add('pcnl-anim');

    var io = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is--in');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.14, rootMargin: '0px 0px -40px 0px' });

    for (var i = 0; i < nodos.length; i++) io.observe(nodos[i]);

    // Red de seguridad: si algo quedó sin revelar (observer perdido, contenido
    // cargado tarde), a los 3s se muestra igual. Nunca contenido invisible.
    setTimeout(function () {
      revelarTodo(document.querySelectorAll('.pcn-landing .pcnl-rv:not(.is--in)'));
    }, 3000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/**
 * Fix iOS/Safari — formularios de Shopify Forms (shadow DOM).
 *
 * En Safari tactil, el click que se sintetiza tras un tap se dispara contra
 * el HOST <shopify-forms-embed> en vez del control interno del shadow DOM:
 * el campo nunca recibe mousedown/focus y el teclado no abre. Reproducido en
 * WebKit (tap -> click en el host, foco null; click de mouse -> funciona).
 *
 * Si un click llega DISPARADO en el propio host (composedPath()[0] === host,
 * o sea que no vino retargeteado desde adentro), buscamos el control real
 * bajo el dedo con elementFromPoint del shadow root y lo activamos. En
 * navegadores sanos el click ya nace en el control interno y esto no actua.
 */
(function () {
  'use strict';

  // Misma guarda que assets/pcn-forms-ios-fix.js (incluido global desde
  // theme.liquid): solo una de las dos copias se engancha. Evita duplicar
  // click() en botones si ambos archivos cargan en una landing.
  if (window.__pcnFormsIosFix) return;
  window.__pcnFormsIosFix = true;

  document.addEventListener('click', function (e) {
    var host = e.target;
    if (!host || !host.tagName || host.tagName !== 'SHOPIFY-FORMS-EMBED') return;

    // Click legitimo originado dentro del shadow DOM: llega retargeteado al
    // host pero composedPath()[0] es el control interno. No intervenir
    // (tambien evita loops cuando abajo re-disparamos click()).
    var origen = e.composedPath ? e.composedPath()[0] : host;
    if (origen !== host) return;

    var sr = host.shadowRoot;
    if (!sr || !sr.elementFromPoint) return;

    var el = sr.elementFromPoint(e.clientX, e.clientY);
    if (!el || !el.closest) return;

    var control = el.closest('input, textarea, select, button, label');
    if (!control) return;

    var esToggle = control.tagName === 'INPUT' && (control.type === 'checkbox' || control.type === 'radio');
    if (control.tagName === 'BUTTON' || esToggle) {
      control.click();
    } else if (control.tagName === 'LABEL') {
      var interno = control.control || control.querySelector('input, textarea, select');
      if (interno) interno.focus();
    } else if (sr.activeElement !== control) {
      control.focus();
    }
  }, true);
})();
